import { Persistor } from 'redux-persist/es/types';

let persistorInstance: Persistor | null = null;

export const setPersistorInstance = (persistor: Persistor): void => {
  persistorInstance = persistor;
};

export const getPersistorInstance = (): Persistor | null => {
  if (!persistorInstance) {
    console.error("Persistor instance has not been set. This might lead to unexpected behavior if accessed before initialization.");
  }
  return persistorInstance;
};

